module.exports = __webpack_public_path__ + "static/media/digital-church-platform.baee0243.png";